import { useLocation } from 'react-router-dom';

import { NavigationTabs } from 'shared/ui/navigation-tabs';

import { TABS } from '../../consts';
import { usePersonsGroupFetchingContext } from '../../context';

export function PersonsGroupTabs() {
  const { fetchingTab } = usePersonsGroupFetchingContext();

  const location = useLocation();

  return (
    <NavigationTabs
      tabs={TABS}
      fetchingTab={fetchingTab}
      rootPath={location.pathname}
    />
  );
}
